var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.51852 3.42969H2.98017C1.98267 3.42969 1.16602 4.24635 1.16602 5.24385V11.8705C1.16602 12.7164 1.77268 13.078 2.51351 12.6638L4.80601 11.3863C5.05101 11.2522 5.44768 11.2522 5.68685 11.3863L7.97935 12.6638C8.72018 13.078 9.32684 12.7164 9.32684 11.8705V5.24385C9.33268 4.24635 8.51602 3.42969 7.51852 3.42969Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33268 5.24385V11.8705C9.33268 12.7164 8.72602 13.0722 7.98518 12.6638L5.69269 11.3863C5.44769 11.2522 5.05101 11.2522 4.80601 11.3863L2.51351 12.6638C1.77268 13.0722 1.16602 12.7164 1.16602 11.8705V5.24385C1.16602 4.24635 1.98267 3.42969 2.98017 3.42969H7.51852C8.51602 3.42969 9.33268 4.24635 9.33268 5.24385Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8327 2.98115V9.60783C12.8327 10.4537 12.226 10.8095 11.4852 10.4012L9.33268 9.19949V5.24449C9.33268 4.24699 8.51602 3.43033 7.51852 3.43033H4.66602V2.98115C4.66602 1.98365 5.48267 1.16699 6.48017 1.16699H11.0185C12.016 1.16699 12.8327 1.98365 12.8327 2.98115Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarksIcon);
export default __webpack_public_path__ + "static/media/bookmarks-icon.dd58dfd3ae14b2c5d4ba1ea0e7206cd7.svg";
export { ForwardRef as ReactComponent };